import Layout from '../../components/layout/Layout';
import { AboutHome } from './AboutHome';
import { ProductsCredt } from './ProductsCredt';
import { useHome } from './hook/useHome';

import HowSolicitationConsignadoINSS from '../consignadoINSS/HowSolicitationConsignadoINSS'
import { HowAnticipate } from '../fgts/HowAnticipateFgts';
import CreditCard from '../benefitCard/CreditCard';
import WhyWithdraw from '../withdrawCard/WhyWithdraw';
import AdvantagesOfWithdrawal from '../withdrawCard/AdvantagesOfWithdrawal';
import BmgMedPlans from '../insurance/BmgMedPlans';
import { WhatIsFamilyLifeInsurance } from '../insurance/WhatIsFamilyLifeInsurance';

function Home() {
    const {
        setTypeProductSelected,
        typeProductSelected,
        typeProducts,
        getSubHeader,
        onGoToRegister
    } = useHome();

    return (
        <Layout subHeader={getSubHeader()}>
            <AboutHome onGoToRegister={onGoToRegister} />
            <ProductsCredt
                onGoToRegister={onGoToRegister}
                setTypeProductSelected={setTypeProductSelected}
                typeProductSelected={typeProductSelected}
                typeProducts={typeProducts}
            />
            <HowSolicitationConsignadoINSS onGoToRegister={onGoToRegister} />
            <HowAnticipate onGoToRegister={onGoToRegister} />
            <CreditCard className='p-8' onGoToRegister={onGoToRegister} />
            <AdvantagesOfWithdrawal onGoToRegister={onGoToRegister} />
            <WhyWithdraw onGoToRegister={onGoToRegister} />
            <BmgMedPlans onGoToRegister={onGoToRegister} />
            <WhatIsFamilyLifeInsurance onGoToRegister={onGoToRegister} />
        </Layout>
    );
}

export default Home;